"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.global_save = exports.global_options = exports.TSSaveGame = exports.TSOptions = void 0;
const KHOptions_1 = require("./KH/KHOptions");
const KHPersistentReference_1 = require("./KH/References/KHPersistentReference");
class TSOptions extends KHOptions_1.KHOptions {
    constructor() {
        super('TS_options', [
            new KHPersistentReference_1.KHPersistentReference('mute', false),
            new KHPersistentReference_1.KHPersistentReference('colorblind', false),
            new KHPersistentReference_1.KHPersistentReference('scale', 10),
        ]);
        this.mute = this.get('mute');
        this.colorblind = this.get('colorblind');
        this.scale = this.get('scale');
    }
}
exports.TSOptions = TSOptions;
class TSSaveGame extends KHOptions_1.KHOptions {
    constructor() {
        super('TS_save', [
            new KHPersistentReference_1.KHPersistentReference('seed', Math.floor(Math.random() * 10000)),
            new KHPersistentReference_1.KHPersistentReference('level', 0),
            new KHPersistentReference_1.KHPersistentReference('wins', 0),
        ]);
        this.seed = this.get('seed');
        this.level = this.get('level');
        this.wins = this.get('wins');
    }
}
exports.TSSaveGame = TSSaveGame;
exports.global_options = new TSOptions();
exports.global_save = new TSSaveGame();
